(() => {
  if (window.tekCategoriesLoaded) return;
  window.tekCategoriesLoaded = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = 'true';
    const pause = root.querySelector('[data-category-pause]');
    const cards = [...root.querySelectorAll('[data-category-card]')];
    const states = cards.map(card => ({card, photos: [], index: 0, visible: false}));
    let paused = motion.matches;
    let timer;
    function updateControl() {
      pause.hidden = !states.some(state => state.photos.length > 1);
      pause.textContent = paused ? 'Play photos' : 'Pause photos';
      pause.setAttribute('aria-pressed', String(paused));
    }
    pause.addEventListener('click', () => { paused = !paused; updateControl(); });
    const onMotion = () => { paused = motion.matches; updateControl(); };
    motion.addEventListener('change', onMotion);
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const state = states.find(s => s.card === entry.target);
        if (!state) continue;
        state.visible = entry.isIntersecting;
        if (state.visible && !state.requested) { state.requested = true; load(state); }
      }
    }, {rootMargin: '100px'});
    async function inventoryPhotos(card, catalog) {
      let url=new URL(card.dataset.inventoryFeed || card.dataset.dockFeed || card.dataset.cameraFeed || card.dataset.laptopFeed,location.origin);
      url.searchParams.set('section_id','tek-memory-feed');
      const pages=new Set(),handles=new Set(),photos=[];
      while(url){
        if(url.origin!==location.origin||pages.has(url.href))throw new Error('Invalid inventory page');
        pages.add(url.href);
        const response=await fetch(url,{signal:AbortSignal.timeout(12000),cache:'no-store'});
        if(!response.ok)throw new Error('Inventory unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        if(!doc.querySelector('[data-memory-feed]'))throw new Error('Inventory unavailable');
        for(const template of doc.querySelectorAll('template[data-memory-item]')){
          if(handles.has(template.dataset.handle)||!catalog.classify(template.dataset))continue;
          handles.add(template.dataset.handle);
          const photo=template.content.querySelector('.tp-product-image img');
          if(photo)photos.push(photo);
          if(photos.length===4)return photos;
        }
        const next=doc.querySelector('[data-memory-next]');url=next?new URL(next.getAttribute('href'),url):null;
        if(url)url.searchParams.set('section_id','tek-memory-feed');
      }
      return photos;
    }
    async function load(state) {
      const frame = state.card.querySelector('.tp-category-photo');
      try {
        let candidates;
        const catalog=state.card.dataset.extraTrigger&&window.tekExtraCatalog?{classify:data=>window.tekExtraCatalog.classify(data,state.card.dataset.extraTrigger)}:state.card.hasAttribute('data-video-trigger')?window.tekVideoCatalog:state.card.hasAttribute('data-toner-trigger')?window.tekTonerCatalog:state.card.hasAttribute('data-dock-trigger')?window.tekDockCatalog:state.card.hasAttribute('data-camera-trigger')?window.tekCameraCatalog:state.card.hasAttribute('data-laptop-trigger')?window.tekLaptopCatalog:null;
        if(catalog){candidates=await inventoryPhotos(state.card,catalog);}
        else {
        const url = new URL(state.card.href);
        url.searchParams.set('section_id', 'tek-category-photos');
        const response = await fetch(url, {signal: AbortSignal.timeout(12000)});
        if (!response.ok) throw new Error('Category photos unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        candidates = [...doc.querySelectorAll('[data-tp-category-images] img')].slice(0, 4);
        }
        const loaded = await Promise.all(candidates.map(async source => {
          const photo = document.importNode(source, true);
          if(catalog){photo.alt='';photo.loading='eager';}
          try { await photo.decode(); return photo; } catch { return null; }
        }));
        if (!state.card.isConnected) return;
        state.photos = loaded.filter(Boolean);
        if (state.photos.length) {
          frame.append(...state.photos);
          state.photos[0].classList.add('is-current');
          frame.dataset.loaded = 'true';
        }
        updateControl();
      } catch { /* Keep the category link and icon usable when images are unavailable. */ }
    }
    states.forEach(state => observer.observe(state.card));
    timer = setInterval(() => {
      if (!root.isConnected) {
        clearInterval(timer); observer.disconnect(); motion.removeEventListener('change', onMotion); return;
      }
      if (paused || document.hidden) return;
      for (const state of states) {
        if (!state.visible || state.photos.length < 2 || state.card.matches(':hover, :focus-within')) continue;
        state.photos[state.index].classList.remove('is-current');
        state.index = (state.index + 1) % state.photos.length;
        state.photos[state.index].classList.add('is-current');
      }
    }, 5000);
  }
  function scan() { document.querySelectorAll('[data-category-gallery]').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
